import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const DICT = {
  fr: {
    tagline: "coaching course à pied",
    eyebrow: "Coaching course à pied · IA + coach humain",
    login: "Se connecter",
    hero_1: "L'IA construit ton plan de course.",
    hero_2: "Un coach humain",
    hero_3: "t'accompagne.",
    hero_sub: "Un moteur de programmation de course à pied assisté par IA, associé au recul et à l'écoute d'un vrai coach. Technologie puissante derrière, simplicité absolue devant.",
    start_bilan: "Commencer mon bilan coureur IA",
    free_nocard: "Gratuit · sans carte bancaire",
    the_ai: "L'IA",
    ai_desc: "Analyse tes allures et ton historique, applique des règles d'entraînement (80/20, progressivité) et assemble ton plan de course.",
    the_coach: "Le coach humain",
    coach_desc: "Écoute, comprend le contexte, motive et décide des grandes orientations lors de rendez-vous.",
    transparency: "Transparence",
    transp_desc: "Tu sais toujours quand tu échanges avec l'IA. Chaque décision indique QUOI, POURQUOI et sur quelles données.",
    nav_today: "Aujourd'hui", nav_program: "Programme", nav_evolution: "Évolution", nav_profile: "Profil",
    nav_assistant: "Assistant IA",
    menu_measurements: "Mensurations", menu_receipts: "Mes reçus & offre", menu_pricing: "Offres & tarifs",
    menu_coach_follow: "Mon suivi coach", menu_switch_coach: "Espace coach (démo)", menu_logout: "Se déconnecter",
    lang: "Langue",
    choose_plan: "Choisis ton accompagnement", plan_ready: "TON BILAN EST PRÊT",
    per_cycle: "/ cycle", promo_placeholder: "Code promo", promo_apply: "Appliquer",
    recommended: "RECOMMANDÉ",
    start_session: "COMMENCER", today: "Aujourd'hui",
  },
  en: {
    tagline: "running coaching",
    eyebrow: "Running coaching · AI + human coach",
    login: "Sign in",
    hero_1: "AI builds your running plan.",
    hero_2: "A human coach",
    hero_3: "guides you.",
    hero_sub: "An AI-assisted running programming engine, paired with the perspective and care of a real coach. Powerful technology behind, absolute simplicity in front.",
    start_bilan: "Start my AI runner assessment",
    free_nocard: "Free · no credit card",
    the_ai: "The AI",
    ai_desc: "Analyses your paces and history, applies training rules (80/20, progression) and assembles your running plan.",
    the_coach: "The human coach",
    coach_desc: "Listens, understands context, motivates and decides the big directions during appointments.",
    transparency: "Transparency",
    transp_desc: "You always know when you're talking to the AI. Every decision shows WHAT, WHY and on which data.",
    nav_today: "Today", nav_program: "Plan", nav_evolution: "Progress", nav_profile: "Profile",
    nav_assistant: "AI Assistant",
    menu_measurements: "Measurements", menu_receipts: "My receipts & plan", menu_pricing: "Plans & pricing",
    menu_coach_follow: "My coach follow-up", menu_switch_coach: "Coach space (demo)", menu_logout: "Sign out",
    lang: "Language",
    choose_plan: "Choose your plan", plan_ready: "YOUR ASSESSMENT IS READY",
    per_cycle: "/ cycle", promo_placeholder: "Promo code", promo_apply: "Apply",
    recommended: "RECOMMENDED",
    start_session: "START", today: "Today",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  // App forcée en français uniquement (plus de sélecteur de langue).
  const [lang, setLang] = useState("fr");

  useEffect(() => {
    localStorage.setItem("lang", "fr");
    document.documentElement.lang = "fr";
    api.post("/auth/language", { language: "fr" }).catch(() => {});
  }, []);

  const t = useCallback((key) => DICT.fr[key] || key, []);

  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
